import i18n from '@/i18n'
import moment from 'moment';
import CryptoJS from "crypto-js";

export const UserRole = {
    SuperAdmin: '3',
    VacationApprove: '2',
    DeviceApprove: '1',
    Normal: '0'
}
export function getTextOfUserRole(role, locale) {
    i18n.locale = locale;
    switch(role){
        case UserRole.SuperAdmin:
            return i18n.t('web_approver');
        case UserRole.VacationApprove:
            return i18n.t('web_approver');
        case UserRole.DeviceApprove:
            return i18n.t('web_normal_user');
        case UserRole.Normal:
            return i18n.t('web_normal_user');
    }
}
export function getUserRole(userRoleInfo) {
    if (userRoleInfo.indexOf('3') > -1) {
        return '3';
      } else if (userRoleInfo.indexOf('1') > -1) {
        return '1';
      } else if (userRoleInfo.indexOf('2') > -1) {
        return '2';
      } else {
        return '0';
      } 
}
export function isApprover(role) {
    if( role && (role == UserRole.VacationApprove || role == UserRole.SuperAdmin)) {
        return true;
    }
    return false;
}

//“0:InProgress”, “1:Approved”, “2: Rejected",  "3: Cancel"
export const VacationStatus = {
    Cancel: '3',
    Rejected: '2',
    Approved: '1',
    InProgress: '0',
    Empty: '99'
}

export const Weekeend = {
    SAT: 6,
    SUN: 0
}

export function getVacationStatusText(vacationStatus, locale) {
    i18n.locale = locale;
    switch(vacationStatus){
        case VacationStatus.InProgress:
            return i18n.t('vacations_inprogress');
        case VacationStatus.Rejected:
            return i18n.t('vacations_rejected');
        case VacationStatus.Approved:
            return i18n.t('vacations_approved');
        case VacationStatus.Cancel:
            return 'Canceled';
    }
}
export function getVacationStatusColor(vacationStatus) {
    switch(vacationStatus){
        case VacationStatus.InProgress:
            return '#F1BD42';
        case VacationStatus.Rejected:
            return '#E561A9';
        case VacationStatus.Approved:
            return '#3FE090';
        case VacationStatus.Cancel:
            return '#F1BD42';
    }
}

export const ListEvents = {
    reloadAllData: "reloadAllData",
    showLoadingIndicator: "showLoading",
    hideLoadingIndicator: "HideLoading",
    showYesNoDialog: "showYesNoDialog",
    dialogSelectedAction: "dialogSelectedAction",
    showOKDialog: "showOKDialog",
    tappedOKAction: "tappedOKAction",

    showRightMenu: "showMenuView",

    loadDataCompleted:"loadDataComplted",
    setPagination: "setPagination",
    paginationChanged: "pageinationChanged",

    showVacationDetail:"showVacationDetail",
    closeVacationDetail:"closeVacationDetail",

    reloadAllTabs: "reloadAllTabs",
    reloadByFilter: "reloadByFilter",
    calendarDate: "calendarDate",
    vacationList: "vacationList",
    chooseApprovedList: "chooseApprovedList",
    setStatusMonth: "setStatusMonth",
    changeTabName: "ChangeTabName",
}

export const DefaultValues = {
    page_size: 1000,
    none_string: "-",
    no_image: `data:image/png;base64,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`,
}

export const TabNames = {
    MyList: 'MyList',
    Requesting: 'Requesting',
    All: 'All'
}

export const ScreenNames = {
    Calendar: 'Calendar',
    ListVacation: 'ListVacation' 
}

export function setLanguage(currentLanguage){
    //set language 
    i18n.locale  = currentLanguage === 'ja' ? 'ja' : 'en';
}

function getDateTimeFromString(dateTimeString) {
    let parsedDate = moment(dateTimeString, "YYYY-MM-DD HH:mm:ss");
    return parsedDate;
}
function getStringDate(dateTime) {
    return dateTime.format('YYYY-MM-DD');
}
//1: future, 0: today, -1: past
//format: YYYY-MM-DD hh:mm:ss
export function compareVacationDate(fromDate, toDate) {
    let fromDateTime = getDateTimeFromString(fromDate);
    let toDateTime = getDateTimeFromString(toDate);
    let now = moment();
    
    let fromDateString = getStringDate(fromDateTime);
    let toDateString = getStringDate(toDateTime);
    let todayDateString = getStringDate(now);

    if (todayDateString == fromDateString || todayDateString == toDateString
        || (fromDateTime.isBefore(now) && now.isBefore(toDateTime))) {
        return 0;
    } else if (now.isBefore(fromDateTime)) {
        return 1;
    }
    return -1;
}


//Encryp Decrypt
const scretKey = "@dfowsxqwagwEQWx$%$5^675!@1";
export function encryptString(content) {
    if(!content) return null;

    const cipherText = CryptoJS.AES.encrypt(
        content,
        scretKey
      ).toString();
    return cipherText;
}
export function decryptCipher(cipherText) {
    if(!cipherText) return null;

    const bytes = CryptoJS.AES.decrypt(cipherText, scretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
}

function isCheckWeekend(start, end){
    //check start is saturday and sunday, end is saturday and sunday
    if((start.getDay()!=Weekeend.SUN && start.getDay()!=Weekeend.SAT) && (end.getDay()!=Weekeend.SUN && end.getDay()!=Weekeend.SAT)){
        for (let date = new Date(start); date <= end; date.setDate(date.getDate() + 1)) {
            //check if have weekend
            if (date.getDay() === Weekeend.SUN || date.getDay() === Weekeend.SAT) {
                return  true;
            }
        }
    }
    else{
        end.setHours(23, 59, 59, 999);
        start.setHours(0, 0, 0, 0);
        const countDays = Math.ceil((end - start) / (1000 * 3600 * 24)) ;
        if(countDays >= 7){
            return  true;
        }
    }
    return false;
}

function checkUserExists(listUsers, userID){
    return listUsers.some(user => user.userID === userID);
}

//grouped Dates data
export function groupedDatesbyId(vacations, fromDate, toDate, userInfo, caseReturn) {
    let groupedDates = {};
    toDate.setHours(23, 59, 59, 999);
    fromDate.setHours(0, 0, 0, 0);
    vacations.forEach(vacation => {
      let vacationFromDate = new Date(vacation.from_date.replace(' ', 'T'));
      let vacationToDate = new Date(vacation.to_date.replace(' ', 'T')); 
  
      if (vacationFromDate <= toDate && vacationToDate >= fromDate) {
        let start = vacationFromDate > fromDate ? vacationFromDate : fromDate;
        let end = vacationToDate < toDate ? vacationToDate : toDate;
        // Only get user exist have vacation
        if (checkUserExists(userInfo, vacation.user_id)) {
            // During start, end have contain sat, sun.
            if(isCheckWeekend(vacationFromDate, vacationToDate)) {
                for (let date = new Date(start); date <= end; date.setDate(date.getDate() + 1)) {
                    if( date.getDay() != Weekeend.SUN && date.getDay() != Weekeend.SAT ){
                        getGroupDate(date, groupedDates, caseReturn, vacation);
                    }
                }
            } else {
                // start and end is  sat or sun and  start to end don't contain Sat and Sun. 
                for (let date = new Date(start); date <= end || date.toDateString() === end.toDateString(); date.setDate(date.getDate() + 1)) {
                    getGroupDate(date, groupedDates, caseReturn, vacation);
                }
            }
        }
      }
    });
    let sortedDates = Object.keys(groupedDates).sort();
    let sortedGroupedDates = {};
    sortedDates.forEach(date => {
      sortedGroupedDates[date] = groupedDates[date];
    });
    
    return sortedGroupedDates;
}
export const resizeMixin = {
    data() {
        return {
            isMobile: false
        };
    },
    methods: {
        handleResize() {
            this.isMobile = window.innerWidth < 768; 
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }
};

function getGroupDate(date, groupedDates, caseReturn, vacation) {
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
    let dateString = `${year}-${month}-${day}`;

    if (!groupedDates[dateString]) {
        groupedDates[dateString] = [];
    }
    if (caseReturn === 'calendar') {
        groupedDates[dateString].push(vacation.status);
    } else {
        groupedDates[dateString].push(vacation.id);
    }
}
